document.addEventListener("DOMContentLoaded", () => {
  // One-time scan to hide "seconds ago" text from review widgets
  function hideSecondsAgoText() {
    const walker = document.createTreeWalker(
      document.body, NodeFilter.SHOW_TEXT, null
    );
    while (walker.nextNode()) {
      if (/second(s)? ago/i.test(walker.currentNode.textContent)) {
        walker.currentNode.textContent = "";
      }
    }
  }
  // Run once now and once more after async widgets load
  hideSecondsAgoText();
  setTimeout(hideSecondsAgoText, 2500);
});

// Mega-nav brand loading - lazy-loaded on hover
(function() {
  function slugToTitle(slug) {
    return slug
      .split('-')
      .map(w => w.charAt(0).toUpperCase() + w.slice(1).toLowerCase())
      .join(' & ');
  }
  
  const fetchCache = {};
  const loadedMenus = new Set();

  function loadTopVendors(handle) {
    const cacheKey = "megaBrands_" + handle;
    
    try {
      const cache = localStorage.getItem(cacheKey);
      if (cache) {
        const parsed = JSON.parse(cache);
        const now = Date.now();
        if (parsed.expiry > now) {
          return Promise.resolve(parsed.vendors);
        }
      }
    } catch (e) {
      // localStorage error - continue with fetch
    }

    if (fetchCache[handle]) {
      return fetchCache[handle];
    }

    // Reduced payload: limit=50 instead of 250
    fetchCache[handle] = fetch(`/collections/${handle}/products.json?limit=50`)
      .then(res => res.json())
      .then(data => {
        if (!data.products) return [];

        const count = {};
        data.products.forEach(p => {
          if (p.vendor) {
            count[p.vendor] = (count[p.vendor] || 0) + 1;
          }
        });

        const vendors = Object.entries(count)
          .sort((a, b) => b[1] - a[1])
          .slice(0, 10)
          .map(([vendor]) => vendor)
          .sort((a, b) => a.localeCompare(b));

        try {
          localStorage.setItem(cacheKey, JSON.stringify({
            vendors,
            expiry: Date.now() + 24 * 60 * 60 * 1000
          }));
        } catch (e) {
          // localStorage quota exceeded - silently fail
        }

        return vendors;
      })
      .catch(() => []);

    return fetchCache[handle];
  }

  function loadBrandsForMenu(parentEl) {
    const idClass = Array.from(parentEl.classList).find(cls =>
      cls.startsWith('navmenu-id-')
    );
    if (!idClass) return;

    const collectionName = idClass.replace('navmenu-id-', '');
    if (loadedMenus.has(collectionName)) return;
    
    loadedMenus.add(collectionName);
    
    const megaListEl = parentEl.querySelector('.mega-brands-wrapper');
    if (!megaListEl) return;

    const heading = megaListEl.querySelector('h6');
    if (heading) {
      heading.textContent = "Top Brands in " + slugToTitle(collectionName);
    }

    loadTopVendors(collectionName).then(vendors => {
      if (!vendors || !vendors.length) return;

      let html = "";
      vendors.forEach(vendor => {
        html += `<li><a href="/collections/vendors?q=${encodeURIComponent(vendor)}">${vendor}</a></li>`;
      });
      const ul = megaListEl.querySelector('ul');
      if (ul) ul.innerHTML = html;
    });
  }

  // Setup hover listeners on nav items (lazy-load on first interaction)
  document.addEventListener("DOMContentLoaded", () => {
    const brandBlocks = document.querySelectorAll(".mega-brands");
    if (!brandBlocks.length) return;

    const parents = document.querySelectorAll('.navmenu-meganav__item-parent');
    parents.forEach(parentEl => {
      parentEl.addEventListener('mouseenter', () => loadBrandsForMenu(parentEl), { once: true });
      parentEl.addEventListener('focusin', () => loadBrandsForMenu(parentEl), { once: true });
    });
  });
})();

// Nav menu overlay observer
(function() {
  const navMenus = document.querySelectorAll('.navmenu-meganav');
  const siteMain = document.querySelector('.site-main');
  if (!siteMain) return;
  
  const config = { attributes: true, attributeFilter: ['data-animation-state'] };
  let openMenus = new Set();

  navMenus.forEach((navMenu, index) => {
    const observer = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        const animationState = navMenu.getAttribute('data-animation-state');
        
        if (animationState === 'open') {
          openMenus.add(index);
          siteMain.classList.add('overlay-active');
        } else if (animationState === 'closed') {
          openMenus.delete(index);
          if (openMenus.size === 0) {
            siteMain.classList.remove('overlay-active');
          }
        }
      });
    });

    observer.observe(navMenu, config);
  });
})();

(function() {
  document.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll('[data-sticky-atc]').forEach(stickyBar => {
      const product = stickyBar.closest('.product--outer');
      const originalAtc = product && product.querySelector('[data-product-atc]');
      if (!product || !originalAtc) return;

      const buyBox = product.querySelector('[data-product-form-area]') || originalAtc;
      const variantSelection = buyBox.querySelector('[data-variant-selection]');
      const pricing = product.querySelector('[data-product-pricing]');
      const stickyPrice = stickyBar.querySelector('[data-sticky-atc-price]');
      const stickyVariant = stickyBar.querySelector('[data-sticky-atc-variant]');
      const stickyButton = stickyBar.querySelector('[data-sticky-atc-button]');
      let currentVariant = null;

      stickyBar.setAttribute('aria-hidden', 'true');
      stickyBar.inert = true;

      const syncPrice = () => {
        if (!stickyPrice || !pricing) return;
        const currentPrice = pricing.querySelector('[data-price-container] [data-price]');
        if (!currentVariant) {
          stickyPrice.textContent = '';
          return;
        }
        if (currentPrice) stickyPrice.textContent = currentPrice.textContent.trim();
      };

      const syncVariant = variant => {
        currentVariant = variant || null;
        if (stickyVariant) {
          stickyVariant.textContent = variant && variant.title !== 'Default Title' ? variant.title : '';
        }
        if (!currentVariant && stickyPrice) stickyPrice.textContent = '';
        queueMicrotask(syncPrice);
      };

      if (pricing) {
        new MutationObserver(syncPrice).observe(pricing, { childList: true, characterData: true, subtree: true });
      }
      if (variantSelection) {
        variantSelection.addEventListener('variant-change', event => syncVariant(event.detail.variant));
        if (typeof variantSelection.getVariant === 'function') {
          variantSelection.getVariant().then(syncVariant).catch(() => {
            if (stickyPrice) stickyPrice.textContent = '';
          });
        }
      }

      const observer = new IntersectionObserver(entries => {
        entries.forEach(entry => {
          const visible = !entry.isIntersecting;
          stickyBar.classList.toggle('sticky-atc-bar--visible', visible);
          stickyBar.setAttribute('aria-hidden', visible ? 'false' : 'true');
          stickyBar.inert = !visible;
        });
      }, { threshold: 0, rootMargin: '0px 0px -80px 0px' });
      observer.observe(originalAtc);

      if (stickyButton) {
        stickyButton.addEventListener('click', () => {
          const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
          buyBox.scrollIntoView({ behavior: reducedMotion ? 'auto' : 'smooth', block: 'center' });
          const firstField = buyBox.querySelector(
            'input[type="radio"]:not(:disabled), select:not([style*="display: none"]):not(:disabled), [data-product-atc]:not(:disabled)'
          );
          if (firstField) {
            setTimeout(() => {
              try { firstField.focus({ preventScroll: true }); }
              catch (error) { firstField.focus(); }
            }, reducedMotion ? 0 : 400);
          }
        });
      }
    });
  });
})();
